<!-- 权限模板 -->
<template>
	<div class='page_content'>
		<settingJurisdictionTemplate ref="settingJurisdictionTemplate"></settingJurisdictionTemplate>
		<div class="page_content_top">
			<v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getDataList()" :showRefresh="true"  :buttonFlag="false"></v-button>
		</div>
		<div class="page_content_center">
			<el-table size="mini" stripe :data="dataList" :height="tableHeight" :key="$store.state.tableNum" border
				style="width: 100%" highlight-current-row>
				<el-table-column label="选择操作" width="80">
					<template slot-scope="scope">
						<el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
							<i class="el-icon-thumb"></i>
						</el-radio>
					</template>
				</el-table-column>
				<el-table-column prop="jteId" label="ID">
				</el-table-column>
				<el-table-column prop="jteName" label="模板名称">
				</el-table-column>
				<!-- <el-table-column prop="jurtemre" label="权限列表" >
							<template slot-scope="scope">
								{{scope.row.jurtemre}}
							</template>
						</el-table-column> -->
			</el-table>
		</div>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import settingJurisdictionTemplate from '@/components/settingJurisdictionTemplate.vue'
export default {
	//import引入的组件需要注入到对象中才能使用
	components: {settingJurisdictionTemplate},
	data() {
		//这里存放数据
		return {
			tableHeight: 0,
			buttonList: [],
			dataList: [],
			selectedDataIndex: 0,
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {},
	//方法集合
	methods: {
		// 动作集合
		actionSet(actionData) {
			switch (actionData.actionType) {
				case 0:
					this.$refs['settingJurisdictionTemplate'].openBox(actionData.actionType, '')
					break;
				case 1:
					if (this.dataList <= 0) {
						this.$message({
							message: '暂无数据',
							type: 'error'
						});
						return false
					}
					var dataInfo = this.dataList[this.selectedDataIndex]
					if (!dataInfo) {
						this.$message({
							message: '请先选中要操作的数据',
							type: 'error'
						});
						return false
					}
					this.$refs['settingJurisdictionTemplate'].openBox(actionData.actionType, dataInfo)
					break;
				case 2:
					this.delDataAction()
					break;
			}
		},

		// 删除
		delDataAction() {
			if (this.dataList <= 0) {
				this.$message({
					message: '暂无数据',
					type: 'error'
				});
				return false
			}
			var dataInfo = this.dataList[this.selectedDataIndex]
			if (!dataInfo) {
				this.$message({
					message: '请先选中要操作的数据',
					type: 'error'
				});
				return false
			}
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.delTem(dataInfo)
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		async delTem(dataInfo) {
			var delData = {
				ids: [dataInfo.jteId]
			}
			let responseData = await this.$http.delJurisdictionTemplate(delData)
			if (responseData.status == 200) {
				this.$message({
					type: 'success',
					message: '删除成功!'
				});

			} else {
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
			this.getDataList()
		},



		async getButtonList() {
			this.buttonList = await this.$common.getActionButton()
		},

		// 获取模板
		async getDataList() {
			let responseData = await this.$http.getJurisdictionTemplate()
			if (responseData.status == 200) {
				this.dataList = responseData.result
				this.selectedDataIndex = 0
			} else {
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}

		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getDataList()
		this.getButtonList()
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() { }, //生命周期 - 创建之前
	beforeMount() { }, //生命周期 - 挂载之前
	beforeUpdate() { }, //生命周期 - 更新之前
	updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
	beforeDestroy() { }, //生命周期 - 销毁之前
	destroyed() { }, //生命周期 - 销毁完成
	activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped></style>
